var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLegality(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136_374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.91824 9.21023C6.86825 9.11526 6.90472 8.99775 6.99969 8.94776L12.284 6.16633C12.379 6.11635 12.4965 6.15281 12.5465 6.24778L14.2153 9.41836C14.2653 9.51333 14.2288 9.63084 14.1339 9.68083L8.84956 12.4623C8.75459 12.5122 8.63708 12.4758 8.5871 12.3808L6.91824 9.21023Z",
    stroke: "#ACACB4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46933 10.351C3.26573 9.96415 3.41425 9.48552 3.80107 9.28192L5.38636 8.44749C5.77317 8.24389 6.2518 8.39242 6.4554 8.77923L8.68054 13.0067C8.88414 13.3935 8.73562 13.8721 8.3488 14.0757L6.76351 14.9101C6.3767 15.1137 5.89807 14.9652 5.69447 14.5784L3.46933 10.351Z",
    stroke: "#ACACB4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4527 5.62245C12.2491 5.23563 12.3977 4.75701 12.7845 4.55341L14.3698 3.71898C14.7566 3.51538 15.2352 3.6639 15.4388 4.05071L17.6639 8.27816C17.8675 8.66497 17.719 9.1436 17.3322 9.3472L15.7469 10.1816C15.3601 10.3852 14.8815 10.2367 14.6779 9.84989L12.4527 5.62245Z",
    stroke: "#ACACB4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9645 19.7303L10.3189 11.9244L12.8588 10.5875L17.2297 18.0117C17.7647 18.9204 17.4315 20.092 16.4983 20.5831C15.5651 21.0743 14.4108 20.6858 13.9645 19.7303Z",
    stroke: "#ACACB4",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegality);
export default __webpack_public_path__ + "static/media/icon_legality.b22474296cf29c75c3a83970452af987.svg";
export { ForwardRef as ReactComponent };